import LoadingModalView from './LoadingModal.view';
export * from './LoadingModal.view';

export const LoadingModal = (props) => LoadingModalView(props);

export default LoadingModal;
